import { addDays, differenceInCalendarDays, format, startOfDay } from "date-fns";
import { parseDateOnly } from "./date-utils";

export const calendarSelectionMode = (checkIn: string, checkOut: string) =>
  checkIn && !checkOut ? "checkout" : "checkin";

/** Checkout is exclusive: booked nights and buffer nights must never be occupied. */
export function validateCalendarStay(
  checkIn: string,
  checkOut: string,
  minNights: number,
  blocked: ReadonlySet<string>,
  isCovered: (date: string) => boolean,
): string | null {
  const from = parseDateOnly(checkIn);
  const to = parseDateOnly(checkOut);
  if (!from || !to || checkOut <= checkIn) return "Please select valid check-in and check-out dates.";
  if (startOfDay(from) < startOfDay(new Date())) return "Please select a future check-in date.";
  if (differenceInCalendarDays(to, from) < minNights) return `This home requires a minimum stay of ${minNights} nights. Choose a later checkout.`;
  for (let day = startOfDay(from); day < startOfDay(to); day = addDays(day, 1)) {
    const ymd = format(day, "yyyy-MM-dd");
    if (!isCovered(ymd)) return "Availability is not loaded for these dates. Please wait or retry.";
    if (blocked.has(ymd)) return "Selected dates are unavailable for this home, including its turnover days. Please change dates.";
  }
  return null;
}